/**
 * Gate 1 — Step 3: Trust Metrics Register REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) =>
  `${API_BASE_URL}/projects/${projectId}/gate1/metrics-register`;

export async function fetchMetricsRegister(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function generateMetricsRegister(projectId) {
  const res = await axios.post(`${base(projectId)}/generate`);
  return res.data;
}

export async function addMetric(projectId, metric) {
  const res = await axios.post(`${base(projectId)}/metrics`, metric);
  return res.data;
}

export async function updateMetric(projectId, metricRowId, patch) {
  const res = await axios.put(`${base(projectId)}/metrics/${metricRowId}`, patch);
  return res.data;
}

export async function deleteMetric(projectId, metricRowId) {
  const res = await axios.delete(`${base(projectId)}/metrics/${metricRowId}`);
  return res.data;
}
